export enum ProjectType {
  Billable = 'Facturable',
  Intern = 'Interne',
  Strategic = 'Projet stratégique',
  Commercial = 'Développement commercial',
  Other = 'Autre'
}
